import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";

import Button from "../button/Button";
import ErrorMessage from "../errorMessage/ErrorMessage";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginLeft: 36,
    },
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 80px)",
      marginLeft: 80,
      marginRight: 0,
    },
  },
}));

function YesNoDialogModal({ title, onSubmit, onClose, submitting, error }) {
  return (
    <StyledDialog open={true} fullWidth onClose={onClose}>
      <DialogTitle id="create-task-dialog-title">Are you sure?</DialogTitle>
      <DialogContent>
        <div>{title}</div>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </DialogContent>
      <DialogActions>
        {onClose && (
          <Button
            title="No"
            onClick={onClose}
            style={{ backgroundColor: "rgb(243, 243, 243)", color: "#222" }}
          />
        )}
        {onSubmit && (
          <Button title="Yes" onClick={onSubmit} submitting={submitting} />
        )}
      </DialogActions>
    </StyledDialog>
  );
}

export default YesNoDialogModal;
